<template>
  <vc-audio-player
    :color="$config.colors.lighter"
    :compact="compact"
    :tracks="player.tracks"
    :artist="player.artist"
    :year="player.year"
    :art="player.art"
    :album="player.album"
    :default-track="defaultTrack"
    :track-action-icon="trackActionIcon"
    :track-action-icon-hint="trackActionIconHint"
    :show-info-header="false"
    :show-art="false"
    :max-width="maxWidth"
    :controls="controls"
    @track-action-icon-click="onTrackActionIconClick" />
</template>
<script>
import moment from 'moment'
import methods from '../mixins/methods'

export default {
  name: 'OnPageVcAudioPlayer',
  mixins: [
    methods
  ],
  props: {
    controls: {
      type: Array,
      required: false,
      default: () => {
        return [
          'previous',
          'playpause',
          'next',
          'scrobber',
          'volume'
        ]
      }
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    trackActionIcon: {
      type: String,
      required: false
    },
    maxWidth: {
      type: String,
      required: false
    },
    trackActionIconHint: {
      type: String,
      required: false
    },
    album: {
      type: [
        Number,
        String
      ],
      required: true
    },
    track: {
      type: [
        Number,
        String
      ],
      required: false,
      default: null
    }
  },
  data () {
    return {
      defaultTrack: 0,
      player: {
        artist: null,
        tracks: [],
        album: null,
        year: null,
        art: null
      }
    }
  },
  mounted () {
    this.getPlayerData()
  },
  methods: {
    onTrackActionIconClick ($event) {
      this.$emit('track-action-icon-click', $event)
    },
    setPlayerData (data) {
      const tracks = []
      data.tracks.forEach(track => {
        tracks.push({
          title: track.title, // required
          src: track.file['mp3-128'], // required
          art: track.art_lg,
          duration: track.duration,
          trackId: track.id,
          url: track.title_link,
          slug: track.title_link.split('/').pop(),
          albumId: this.album
        })
      })
      this.player.artist = data.artist
      this.player.album = data.album_title
      this.player.year = moment(data.publish_date).format('YYYY')
      this.player.art = data.album_art_lg
      if (this.track) {
        const index = tracks.findIndex(track => parseInt(track.trackId) === parseInt(this.track, 10))
        this.defaultTrack = index !== -1 ? index : 0
      }
      this.player.tracks = tracks
      if (this.track) {
        this.player.defaultTrack = this.defaultTrack
        this.cacheData(this.track, 'player', this.player)
      } else {
        this.cacheData(this.album, 'player', this.player)
      }
    },
    getPlayerData () {
      const cachedData = this.retrieveCachedData('player', this.track || this.album)
      if (cachedData) {
        if (this.track) {
          this.defaultTrack = cachedData.defaultTrack
        }
        this.player = cachedData
        return
      }
      const url = 'https://bc.wemakesites.net/api/player'
      this.$http({
        url,
        method: 'POST',
        data: {
          album: this.album
        }
      }).then(response => {
        this.setPlayerData(response.data.data)
      }).catch(error => {
        console.error(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/on-page-vc-audio-player.vue